import { buildWidgetInstanceId } from "features/widgets";
import React from "react";
import { useCollectedData } from "shared/contexts/PageData";
import { useViewMode } from "shared/contexts/ViewMode";

import styles from "./Content012.module.scss";
import { GridView } from "./GridView";
import { SliderView } from "./SliderView";

export const Content012 = ({ payload }) => {
  const instanceId = buildWidgetInstanceId("012", payload.id);
  const { events, articles } = useCollectedData(instanceId, [
    { name: "events", defaultValue: [] },
    { name: "articles", defaultValue: [] },
  ]);

  const now = new Date();

  const filteredEvents = events.filter((event) => {
    return new Date(event.date) <= now;
  });

  const filteredArticles = articles.filter((article) => {
    return new Date(article.date) <= now;
  });

  const { isMobile } = useViewMode();
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const contentType = payload?.contentType ?? "";

  return (
    <div className={styles.wrapper}>
      {isMobile ? (
        <GridView
          title={title}
          description={description}
          contentType={contentType}
          events={filteredEvents}
          articles={filteredArticles}
        />
      ) : (
        <SliderView
          title={title}
          description={description}
          contentType={contentType}
          events={filteredEvents}
          articles={filteredArticles}
        />
      )}
    </div>
  );
};

export default Content012;
